/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ExgChipsComponent as ɵa} from './lib/data/exg-chips/exg-chips.component';